import { jsx as _jsx } from "react/jsx-runtime";
import clsx from 'clsx';
import { Emoji } from 'emoji-mart-virtualized';
export const SpaceImage = ({ space, size = 'md' }) => {
    var _a, _b, _c, _d, _e, _f;
    const sizeClsx = [
        size === 'xs' && 'h-6 w-6',
        size === 'sm' && 'h-6 w-6',
        size === 'md' && 'h-24 w-24',
        size === 'lg' && 'h-24 w-24',
    ];
    const emojiSize = {
        xs: 16,
        sm: 24,
        md: 64,
        lg: 96,
    };
    return ((_a = space === null || space === void 0 ? void 0 : space.image) === null || _a === void 0 ? void 0 : _a.url) ? (_jsx("div", { className: clsx('flex items-center justify-center', sizeClsx), children: _jsx("img", { alt: space.name, className: clsx('text-basicSurface-400 group-hover:text-basicSurface-500 object-scale-down', 'flex-shrink-0 rounded-md', sizeClsx, size === 'lg' ? 'bg-surface-50 rounded-md p-1' : ''), "aria-hidden": "true", src: size === 'lg' || size === 'md'
                ? (_c = (_b = space === null || space === void 0 ? void 0 : space.image) === null || _b === void 0 ? void 0 : _b.urls) === null || _c === void 0 ? void 0 : _c.small
                : (_e = (_d = space === null || space === void 0 ? void 0 : space.image) === null || _d === void 0 ? void 0 : _d.urls) === null || _e === void 0 ? void 0 : _e.thumb }, void 0) }, void 0)) : (_jsx("div", { className: clsx('text-basicSurface-400 group-hover:text-basicSurface-500', 'flex items-center justify-center', sizeClsx), children: _jsx(Emoji, { native: true, emoji: `:${(_f = space === null || space === void 0 ? void 0 : space.image) === null || _f === void 0 ? void 0 : _f.text}:`, size: emojiSize[size] }, void 0) }, void 0));
};
//# sourceMappingURL=SpaceImage.js.map